<template>
  <div>
    <public-title>添加权限节点
        <span class="text-link ml-auto h6" slot="right" @click="$router.push({name: 'AccessNode',query:{tab:$route.query.active}})">返回列表</span>
    </public-title>
    <!-- <public-title showBack>添加权限节点</public-title> -->
    <div class="bg-white p-5 text-left">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="权限名称：">
          <el-input v-model="form.power_name"/>
        </el-form-item>
        <el-form-item label="权限描述：">
          <el-input v-model="form.remarks"/>
        </el-form-item>
        <el-form-item label="所属身份：" >
          <el-radio-group v-model="form.power_type">
            <el-radio :label="item.value" v-for="item in typeLists" :key="item.title">{{item.title}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="选择父节点：">
          <el-tree :data="accessLists"
                   ref="tree"
                   accordion
                   show-checkbox
                   :check-strictly="true"
                   node-key="id"
                   @check-change="checkChange"
                   @node-click="nodeClick"
                   :props="defaultProps"/>
        </el-form-item>
        <el-form-item label="匹配到职位：">
          <el-checkbox-group class="text-left" v-model="form.position_str">
            <el-checkbox :label="item.id" :title="item.remarks"
                         :key="item.id" v-for="item in positionLists">{{item.name}}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item class="text-center">
          <el-button type="primary" @click="onSubmit">立即创建</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'NodeAddEdit',
    data() {
      return {
        form: {
          power_type: this.$route.query.active,
          position_str: []
        },
        editCheckId: '',          //选择的权限ID
        typeLists: [
          {title: '管理员', value: '1'},
          {title: '采购商', value: '2'},
          {title: '酒店', value: '3'},
          {title: '导游', value: '4'},
          {title: '民宿', value: '5'},
          {title: '景区', value: '6'},
          {title: '品牌馆', value: '8'},
        ],
        positionLists: [],
        accessLists: [],
        defaultProps: {
          children: 'children',
          label: 'title'
        }
      }
    },
    computed: {
      ...mapState(['userLoginMessage'])
    },
    watch: {
      'form.power_type': function () {
        this.form.position_str = [];        //清空上一次选择的职位
        this.getAccessLists();
        this.getPositionLists();
      }
    },
    created() {
      this.getAccessLists();
      this.getPositionLists();
    },
    methods: {
      /*根据身份获取权限数组和相应的职位数组*/
      async getAccessLists() {
        let res = await this.$axios.post('/pc/Admin/GetPositionPowerTree',{is_admin: this.form.power_type});
        if (res.code === '00000' || res.code === '99999') {
          this.accessLists = res.info || [];
          this.accessLists.unshift({
            id:'0',
            title:'顶级权限',
            children:[]
          })
        }
      },
      async getPositionLists() {
        let res = await this.$axios.post('/pc/Admin/PositionList',{type: this.form.power_type});
        if (res.code === '00000') this.positionLists = res.data.list;
      },
      /*控制tree只能被选中一个值*/
      checkChange(item, node, self) {
        if (node) { //点击的是一个未选中的复选框
          this.editCheckId = item.id;
          this.$refs.tree.setCheckedKeys([item.id]);
        } else {
          if (this.editCheckId === item.id) { //点击已选中的复选框
            this.$refs.tree.setCheckedKeys([item.id]);
          }
        }
        this.topAccess = false;
      },
      nodeClick(item, node, self) {
        this.editCheckId = item.id;
        this.$refs.tree.setCheckedKeys([item.id]);
        this.topAccess = false;
      },
      onSubmit() {
        let {power_type,power_name,pid,position_str,remarks} = this.form;
        if (!power_name) { this._alert('请填写权限名称',null,'error'); return }
        if (!this.editCheckId) { this._alert('请选择选择父节点',null,'error'); return }
        if (position_str.length==0) { this._alert('请选择匹配到职位',null,'error'); return }
        this._confirm('确定保存信息么？',async () => {
          let res = await this.$axios.post('/pc/Admin/AddPower',{
            power_type,
            power_name,
            pid:this.topAccess ? '0' : this.editCheckId,
            position_arr :position_str,
            remarks
          });
          if (res.code === '00000') this._alert('保存成功', () => this.$router.push({name: 'AccessNode',query:{tab:power_type}}))
        })
      }
    }
  }
</script>
